import { useTheme } from '@mui/material'
import React from 'react'

const AppleLogo = (props) => {
    const { size = 25 } = props
    const theme = useTheme()
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2275_12134)">
                <path d="M16.6192 0C16.6751 0 16.7309 0 16.7899 0C16.9269 1.69253 16.2809 2.95719 15.4958 3.87301C14.7254 4.78251 13.6704 5.6646 11.9642 5.53076C11.8504 3.86247 12.4975 2.69161 13.2816 1.77789C14.0087 0.92636 15.3419 0.168621 16.6192 0Z" fill={theme.palette.neutral[1000]} />
                <path d="M21.7841 17.6183C21.7841 17.6352 21.7841 17.65 21.7841 17.6658C21.3046 19.118 20.6206 20.3626 19.7859 21.5177C19.024 22.5663 18.0903 23.9774 16.423 23.9774C14.9824 23.9774 14.0254 23.0511 12.549 23.0258C10.9871 23.0005 10.1282 23.8004 8.70019 24.0017C8.53683 24.0017 8.37348 24.0017 8.21329 24.0017C7.16468 23.8499 6.31842 23.0195 5.7019 22.2712C3.88396 20.0602 2.47914 17.2042 2.21777 13.5493C2.21777 13.191 2.21777 12.8337 2.21777 12.4754C2.32843 9.85968 3.59941 7.73295 5.28878 6.70225C6.18036 6.15423 7.40602 5.68737 8.7708 5.89603C9.3557 5.98667 9.95325 6.1869 10.477 6.38503C10.9734 6.57579 11.5941 6.91408 12.1822 6.89617C12.5806 6.88457 12.9768 6.67696 13.3784 6.53047C14.5545 6.10576 15.7074 5.61886 17.2271 5.84756C19.0535 6.12367 20.3498 6.93516 21.1507 8.18717C19.6057 9.17044 18.3843 10.6522 18.593 13.1826C18.7784 15.4811 20.1148 16.8258 21.7841 17.6183Z" fill={theme.palette.neutral[1000]} />
            </g>
            <defs>
                <clipPath id="clip0_2275_12134">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default AppleLogo